/*!*
 * request 用于发送及初步处理请求，
 * 包括，处理未登录，无权限，基本操作提示信息，以及loading动画，
 * loading 目前只能用默认配置 loadingConfig
 */
import axios from 'axios'
import { AXIOS_TIMEOUT, ACCESS_TOKEN_KEY } from '../config'
import { getToken } from './token'

// 创建axios实例 application/json; charset=UTF-8 // multipart/form-data , application/x-www-form-urlencoded
const CONTENT_TYPE = { 'Content-Type': 'application/x-www-form-urlencoded' }
export const uploadFile = axios.create({
  baseURL: '', // api的base_url
  timeout: AXIOS_TIMEOUT,
  headers: { // axios.defaults.headers
    common: { 'Accept': 'application/json, text/plain, */*' },
    post: CONTENT_TYPE,
    put: CONTENT_TYPE,
    patch: CONTENT_TYPE
  },
  transformRequest: [function (data, headers) {
    // 处理token
    let token = getToken()
    if (token) {
      headers[ACCESS_TOKEN_KEY] = token
    }
    headers['app-type'] = '5'
    return data
  }],
  onUploadProgress (progressEvent) {
    console.log(progressEvent)
    // Do whatever you want with the native progress event
  }
})
